import { FETCH_CLIENT_DOCS } from "../actions/types"

export default function _(state = null, action) {
    switch(action.type) {
        case FETCH_CLIENT_DOCS:
            return action.payload
        default:
            return state
    }
}